//@flow

import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import { ReviewYourBooking } from '../../../../components';

import {
  proceedToTrekPayment,
  searchFlights,
} from '../../../../redux/actions/trekPaymentReviewActions';
import { ConnectedDatePicker, ConnectedCounter } from '../../Common';

import '../../../../../node_modules/flatpickr/dist/themes/airbnb.css';

type Props = {
  // from redux
  startDate: string,
  pax: number,
  numberOfDays: number,
  errorWhenNoFlights: string,
  isFlightsAvailable: boolean | null,
  showBuyTrek: boolean,
  buyTrek: () => void,
  searchFlights: () => void,
  // comes from parent i.e Review.
  totalPrice: number,
};

const mapStateToProps = ({
  trekPayment: {
    trekTemplateStartDate,
    noOfPeople,
    userIsPickingDatesOrPax,
    isFlightsAvailable,
    flights,
  },
  selectedTrek: { trek },
}) => {
  const trekHasNoFlights = isEmpty(flights);

  const getErrorWhenNoFlights = () => {
    if (trekHasNoFlights && !userIsPickingDatesOrPax && !trekTemplateStartDate)
      return 'Please enter your dates';

    if (!trekHasNoFlights && isFlightsAvailable === false)
      return 'Sorry! We didn\'t find any flights. Please change your date and search again';
  };

  return {
    startDate: trekTemplateStartDate,
    pax: noOfPeople,
    numberOfDays: trek.number_of_days,
    errorWhenNoFlights: getErrorWhenNoFlights(),
    showBuyTrek: trekHasNoFlights ? true : isFlightsAvailable && !userIsPickingDatesOrPax,
  };
};

const mapDispatchToProps = dispatch => ({
  buyTrek: () => dispatch(proceedToTrekPayment()),
  searchFlights: () => dispatch(searchFlights()),
});

const BookSection = ({
  startDate,
  pax,
  numberOfDays,
  buyTrek,
  errorWhenNoFlights,
  showBuyTrek,
  searchFlights,
  // comes from parent i.e Review
  totalPrice,
}: Props) => (
  <Fragment>
    <div className="widget-panel">
      <div className="widget-wrap">
        <ConnectedCounter />
        <ConnectedDatePicker error={errorWhenNoFlights} />
        <Message />
      </div>
      <ReviewYourBooking
        pax={pax}
        startDate={startDate}
        numberOfDays={numberOfDays}
        onSubmit={showBuyTrek ? buyTrek : searchFlights}
        buttonText={showBuyTrek ? 'BUY TREK' : 'CHECK FOR AVAILABILITY'}
        totalPrice={totalPrice}
        ImportantNote={<ImportantNote />}
      />
    </div>
  </Fragment>
);

const ImportantNote = () => (
  <Fragment>
    <li style={{ color: '#000' }}>
      <strong>IMPORTANT NOTE</strong>
    </li>
    <li style={{ color: '#000' }}>
      Date Changes of +/- 2 days will be accommodated by all Lodges at No Extra Charge.
      Please contact the Lodge or HoneyGuide.
    </li>
  </Fragment>
);

const Message = () => (
  <p>
    <strong>FREE REFUND</strong>
    <br />
    48 hours for Flights. 1 week for Lodges.
    <br /> 30 days for Guides or Porters.
  </p>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookSection);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/BookSection.js